import React from "react";
import { Route, Redirect } from "react-router-dom";

export const PrivateOnlineRoute = ({ component: Component, ...rest }) => {
  const jwt = sessionStorage.getItem("rT");
  //FIXME maybe change to sessionToken
  return (
    <Route
      {...rest}
      render={(props) => {
        if (jwt !== null) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
